import { useCallback } from 'react';
import { useSiteConfig } from '../context/SiteConfigContext';

export function useT() {
  const config = useSiteConfig();
  const lang = config.meta.lang;
  const translations = config.i18n[lang] || config.i18n['es'];

  const esFallback = config.i18n['es'];

  return useCallback(
    (key, fallback) => {
      if (!key) return fallback || '';
      return translations[key] ?? esFallback?.[key] ?? fallback ?? key;
    },
    [translations, esFallback]
  );
}
